import { useEffect } from "react";
import queryString from "query-string";
import { useSaveConstantContactAuthDataMutation } from "../../../../../api/constantContact/useSaveConstantContactAuthDataMutation";
import { uiNotification } from "../../../../../services/UINotificationService";
import {
  INTEGRATION_STATE_STORAGE_KEY,
  INTEGRATION_SYNC_ALL_KEY,
  INTEGRATION_SYNC_NEW_KEY,
  STATE_QUERY_PARAM,
  TOKEN_QUERY_PARAM,
} from "../config";

export function useAuthenticateIntegration({ onSuccess }) {
  const { mutateAsync } = useSaveConstantContactAuthDataMutation({
    onSuccess,
    onError: () => {
      uiNotification.error("Unable to save integration data. Try again later.");
    },
  });

  const getParams = () => {
    return queryString.parse(window.location.search);
  };

  const getCode = () => {
    return getParams()?.[TOKEN_QUERY_PARAM] || null;
  };

  const getVerificationState = () => {
    return getParams()?.[STATE_QUERY_PARAM] || null;
  };

  useEffect(() => {
    const code = getCode();
    const state = getVerificationState();
    const storedState = sessionStorage.getItem(INTEGRATION_STATE_STORAGE_KEY);

    if (code) {
      if (!state || !storedState || state !== storedState) {
        uiNotification.error("Invalid state parameter.");
        return;
      }

      sessionStorage.removeItem(INTEGRATION_STATE_STORAGE_KEY);

      mutateAsync({
        code,
        isEnabled: true,
        syncAll: localStorage.getItem(INTEGRATION_SYNC_ALL_KEY) === "true",
        syncNew: localStorage.getItem(INTEGRATION_SYNC_NEW_KEY) === "true",
      });
    } else {
      uiNotification.error("Authorization code is missing.");
    }
  }, []);

  return {
    code: getCode(),
  };
}
